import type { FC } from 'react'
import React from 'react'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import Radio from '@material-ui/core/Radio'

const useStyles = makeStyles(() =>
  createStyles({
    root: {},
  }),
)

const CustomRadio: FC = ({ ...rest }) => {
  const classes = useStyles()

  return <Radio className={classes.root} {...rest} />
}

export default CustomRadio as typeof Radio
